import {useMutation, useQueryClient} from '@github-ui/react-query'
import {fetchCAPI} from '@github-ui/copilot-shared-ui/capi/fetch-capi'
import {taskByIdApiPath} from '../utils/api-url-helpers'
import {agentTasksQueryKey} from './useTasks'
import {agentGroupedTasksQueryKey} from './use-grouped-tasks-data'
import {agentTaskPinsQueryKey} from '../utils/task-pins'

interface UseDeleteTaskArgs {
  owner?: string
  repo?: string
  taskId?: string
  apiUrl?: string
}

export function useDeleteTask({owner, repo, taskId, apiUrl}: UseDeleteTaskArgs) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['deleteTask', owner, repo, taskId],
    mutationFn: async () => {
      if (!taskId) {
        throw new Error('taskId is required')
      }

      // Always use the non-repo-scoped path — the delete endpoint only exists at /agents/tasks/{task_id}
      const path = taskByIdApiPath(taskId)
      await fetchCAPI({
        path,
        method: 'DELETE',
        copilotApiUrl: apiUrl,
      })
    },
    onSuccess: () => {
      if (!taskId) return

      void queryClient.invalidateQueries({queryKey: agentTaskPinsQueryKey})
      queryClient.invalidateQueries({queryKey: agentTasksQueryKey})
      queryClient.invalidateQueries({queryKey: agentGroupedTasksQueryKey})

      if (owner && repo) {
        queryClient.invalidateQueries({queryKey: ['repo-tasks', owner, repo]})
      }
    },
  })
}
